import React from 'react'

interface Props {
    children?: React.ReactNode
}
const HorizontalCardRightTop: React.FC<Props> = props => {
    return <>{props.children}</>
}

export default HorizontalCardRightTop
